import { render, staticRenderFns } from "./PasswordEdit.vue?vue&type=template&id=3a798f70&scoped=true&"
import script from "./PasswordEdit.vue?vue&type=script&lang=js&"
export * from "./PasswordEdit.vue?vue&type=script&lang=js&"
import style0 from "./PasswordEdit.vue?vue&type=style&index=0&id=3a798f70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a798f70",
  null
  
)

export default component.exports